import React, {Component} from 'react';
import PropTypes from 'prop-types';


export default class FilterBool extends Component {
  static propTypes = {
    className: PropTypes.string,
    value: PropTypes.bool,
    label: PropTypes.string,
  };

  static defaultProps = {
    className: '',
    onChange: () => {},
    value: false,
    label: ''
  };

  constructor(props) {
    super(props);
    this.state = {
      value: props.value
    };
  }

  onChecked = (event) => {
    this.props.onChange(event.target.checked);
  };

  render() {
    return (
      <div className="filter-bool">
        <div className="form-group">
          <input
            type="checkbox"
            onChange={this.onChecked}
            checked={this.state.relocation}
            id="myBoolean"
          /> <label htmlFor="myBoolean">{this.props.label}</label>
        </div>
      </div>
    );
  }
}